import { actions, mutations } from './concierge.d';
import apiConcierge from '@/api/concierge';
import apiMixpanel from '@/api/mixpanel';
import { Firebase } from '@/api/firebase';
import get from 'lodash/get';

export default {
  /**
   * Initialize Current Concierge
   */
  [actions.setCurrentConcierge]: async function(context, conciergeId) {
    const concierge = await apiConcierge.getConcierge(conciergeId);
    context.commit(mutations.setCurrentConcierge, concierge);
  },

  /**
   * Update Current Concierge
   */
  [actions.updateCurrentConcierge](context, concierge) {
    // TODO: Do update logic here
    return context.commit(mutations.updateCurrentConcierge, concierge);
  },

  /**
   * Update online status for Current Concierge
   */
  [actions.updateConciergeOnlineStatus](context, status) {
    // TODO: Do update logic here
    return context.commit(mutations.updateConciergeOnlineStatus, status);
  },

  /**
   * Initialize concierge list
   */
  [actions.initializeConciergeList]: async function({ commit, rootState }) {
    const conciergeList = await apiConcierge.listConcierge();
    let theConciergeList = conciergeList.filter(concierge => {
      if (concierge.agentId != rootState.Concierge.currentConcierge.agentId) {
        let channelListener = Firebase.getConciergeChannels(concierge.agentId);

        channelListener.on('value', snapshot => {
          concierge.channels = Object.values(snapshot.val() || {});
          commit(mutations.updateConciergeChannel, {
            conciergeId: concierge.agentId,
            conciergeChannels: concierge.channels
          });
        });

        return concierge;
      }
    });

    return commit(mutations.setConciergeList, theConciergeList);
  },

  /**
   * Update concierge list
   */
  [actions.updateConciergeList](context, List) {
    // TODO: Do update logic here
    return context.commit(mutations.updateConciergeList, List);
  },

  /**
   * Update concierge
   */
  [actions.updateConcierge]: async function(context, payload) {
    const { agentId: conciergeId } = context.state.currentConcierge;
    const params = { ...payload, conciergeId };
    const result = await apiConcierge.updateConcierge(params);
    context.commit(mutations.setCurrentConcierge, result);
  },

  /**
   * Update concierge payout
   */
  [actions.updateConciergePayout]: async function({ state, commit }, payload) {
    const { agentId: conciergeId } = state.currentConcierge;
    const { paypalEmail: email } = payload;

    const params = { email, conciergeId, ...payload };
    const result = await apiConcierge.updateConciergePayout(params);
    commit(mutations.setCurrentConcierge, result);
  },

  /**
   * Set Concierge Rewards
   */
  [actions.setConciergeRewards]: async function(context, conciergeId) {
    // TODO: remove conciergeId from params and get it from state like this context.state.currentConcierge
    const rewards = await apiConcierge.getConciergeRewards(conciergeId);
    context.commit(mutations.setConciergeRewards, rewards);
  },

  /**
   * Set Concierge Unique Users
   */
  [actions.setConciergeUniqueUsers]: async function(context, data) {
    const result = await apiMixpanel.queryMixpanel(data.params, data.script);
    context.commit(mutations.setConciergeUniqueUsers, result.data[0]);
  },

  /**
   * Set Concierge Chats
   */
  [actions.setConciergeChats]: async function(context, data) {
    const result = await apiMixpanel.queryMixpanel(data.params, data.script);
    context.commit(
      mutations.setConciergeChats,
      get(result, 'data[0].value', 0)
    );
  },

  /**
   * Set Concierge Profile Visits
   */
  [actions.setConciergeProfileVisits]: async function(context, data) {
    const result = await apiMixpanel.queryMixpanel(data.params, data.script);
    context.commit(
      mutations.setConciergeProfileVisits,
      get(result, 'data[0].value', 0)
    );
  }
};
